import type { FaireProductEntity } from "../../entity_types/product";

export const p_1x9f8hxe: FaireProductEntity = {
  token: "p_1x9f8hxe",
  type: "product",
  name: "Oatmeal Milk & Honey Bath Bomb",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/7304c47d38f5d2595a344e9a648c515631c18ef1677321f65138a4f235985620.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ff6a4196680536c333f1bd7074e7ddfb6d3c4ac18df37948be0c47702a0b61a.jpeg",
    "https://cdn.faire.com/fastly/4f9ad8dbcc85d544489cb891a42704d62089956cd9491ea64bad573e84532bb7.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3de68b51078a4b624e7a364c4d1eaeeb5545023d74bcb48b0840f1079f9a62f8/1530916059.jpg",
    "https://cdn.faire.com/fastly/1f0988d67c8f8637f7ca06340f8cd014d2a7d666761b52579b77ba423a7c9c9a.jpeg",
    "https://cdn.faire.com/fastly/d3c155294f14b3cc01e575f9637a954b9953e1244491c133711b351826c162c4.jpeg",
    "https://cdn.faire.com/fastly/8be44163e5611e40d3e76c0dcbc798bce090530127788c2b46d5bd814ed27f4c.jpeg",
    "https://cdn.faire.com/fastly/8ea2efdd12586cc982bccaa0aa47f07d258518ffc1b3a4b31f92c6e482805e69.jpeg",
    "https://cdn.faire.com/fastly/812ebf9ba771b249726eb7905f97de78352289187e2aa7e1fd924256dcfa6116.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e5e00c095e0609c07c65c8b996bd8bd25c0308757545100fe59900633c3fc940/1536338083.jpg",
    "https://cdn.faire.com/fastly/811e33289be1043254023b276546c49d0f95302387c8d8606fb879020b1e26b1.jpeg",
    "https://cdn.faire.com/fastly/58cfe95c6fdcbca718f484c08c705925c3988b35428c9091b19e34de11c84b4f.jpeg",
  ],
  priceDollars: 4,
  description:
    "A comforting and nostalgic blend, this scent combines warm oatmeal lightly sweetened with Manuka honey, splashes of almond milk and a dash of spicy clove and vanilla. Reminiscent of a warm almond cookie, it is a soothing and slightly sweet scent with hints of spice.\n\nTop: Oatmeal Milk, Honey, Sweet Almond\nBase: Clove, Tonka Bean, Vanilla\n\nHandmade in historic Charleston, SC, with baking soda, citric acid, epsom salts, olive, and soybean oil, each Old Whaling Co. 8oz bath bomb will leave your skin feeling moisturized and lightly scented. Our handcrafted bath bomb's soothing fizz and sea-inspired fragrance are perfect for a relaxing soak, rejuvenating the senses and cleansing the skin.\n\nAt a 2.75” round, our bath bombs are perfect for a single bath. \n\nOur bath bombs come individually boxed, and are wrapped in cellophane bags inside the box.\n\nOur bath bombs always make for great gifts! Our Oatmeal Milk & Honey bath bombs are best sellers all year long!",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:11.299Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
